export default __webpack_public_path__ + "static/media/Unsigned Contract Swiftness.fc56ae99.png";